import React from 'react';

/**
 * ModeToggle — two-state segmented control for switching between
 * Calculate (forward-looking fee math) and Reports (backward-looking sales
 * analysis) modes.
 *
 * Visual: a full-width container that visually matches .sketch-card —
 * 2px ink border, 1rem radius, soft double shadow. Two segments split the
 * width 50/50 via flex: 1. The active segment fills with ink for weight;
 * the inactive segment stays paper and reveals on hover. Sized to fill
 * the column it lives in so it reads as a sibling of the inputs card
 * below, not a floating widget.
 */

const MODES = [
  { id: 'calculate', icon: '🧮', label: 'Calculate' },
  { id: 'reports',   icon: '📊', label: 'Reports' },
];

export default function ModeToggle({ mode, onChange }) {
  return (
    <div
      role="tablist"
      aria-label="Workspace mode"
      style={{
        display: 'flex',
        width: '100%',
        background: '#fefdfa',
        border: '2px solid #1a1a2e',
        borderRadius: '1rem',
        padding: '5px',
        // Match .sketch-card shadow language so it groups with the column
        boxShadow:
          '0 2px 0 rgba(26,26,46,0.08), 0 6px 16px rgba(26,26,46,0.06)',
        gap: '4px',
      }}
    >
      {MODES.map((m) => {
        const active = mode === m.id;
        return (
          <button
            key={m.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(m.id)}
            style={{
              flex: 1,
              padding: '0.55rem 1rem',
              background: active ? '#1a1a2e' : 'transparent',
              color: active ? '#fefdf8' : '#1a1a2e',
              border: 'none',
              // Slightly smaller than the outer 1rem so it nests cleanly
              borderRadius: '0.7rem',
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.95rem',
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'all 0.18s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '0.45rem',
              justifyContent: 'center',
              letterSpacing: '-0.01em',
            }}
            onMouseEnter={(e) => {
              if (!active) e.currentTarget.style.background = 'rgba(26, 26, 46, 0.06)';
            }}
            onMouseLeave={(e) => {
              if (!active) e.currentTarget.style.background = 'transparent';
            }}
          >
            <span style={{ fontSize: '1.05rem', lineHeight: 1 }} aria-hidden="true">
              {m.icon}
            </span>
            <span>{m.label}</span>
          </button>
        );
      })}
    </div>
  );
}
